export default __webpack_public_path__ + "static/media/ionicons.0b4ad617.woff";